import api from "../../services/api";

export function initialRecognitionEligibility(photo) {
  if (photo?.initialRecognition?.eligible === true) return { eligible: true, reasons: [] };
  const reasons = photo?.initialRecognition?.reasons;
  return {
    eligible: false,
    reasons: Array.isArray(reasons) && reasons.length
      ? reasons
      : [{ code: "eligibility_unavailable", message: "Elegibilidade não confirmada. Atualize a fila." }],
  };
}

export function summarizeRecognitionSelection(photos, selectedIds) {
  const selected = new Set(selectedIds);
  const eligibleIds = [];
  const ineligible = [];
  const reasons = new Map();
  photos.filter((photo) => selected.has(photo.id)).forEach((photo) => {
    const eligibility = initialRecognitionEligibility(photo);
    if (eligibility.eligible) {
      eligibleIds.push(photo.id);
      return;
    }
    ineligible.push({ photoId: photo.id, reasons: eligibility.reasons });
    const counted = new Set();
    eligibility.reasons.forEach((reason) => {
      if (counted.has(reason.code)) return;
      counted.add(reason.code);
      const current = reasons.get(reason.code) || { ...reason, count: 0 };
      reasons.set(reason.code, { ...current, count: current.count + 1 });
    });
  });
  return { eligibleIds, ineligible, reasons: Array.from(reasons.values()) };
}

export async function executePublicationBatches({
  eventId, action, photoIds, onProgress, shouldContinue = () => true,
}) {
  const ids = [...new Set(photoIds)];
  const report = { confirmed: [], failed: [], unconfirmed: [], notSent: [], interruption: "" };
  const notify = (sent) => onProgress?.({
    sent, total: ids.length, confirmed: report.confirmed.length,
    failed: report.failed.length, unconfirmed: report.unconfirmed.length,
  });
  for (let offset = 0; offset < ids.length; offset += 100) {
    if (!shouldContinue()) {
      report.notSent = ids.slice(offset).map((photoId) => ({ photoId }));
      report.interruption = "Operação interrompida ao sair da tela.";
      break;
    }
    const batch = ids.slice(offset, offset + 100);
    notify(offset + batch.length);
    let results;
    try {
      const response = await api.post(`/publication/events/${eventId}/bulk`, { photoIds: batch, action });
      results = response.data?.results;
    } catch {
      report.unconfirmed.push(...batch.map((photoId) => ({
        photoId, error: "O envio não teve resposta confirmada. Consulte o estado da foto antes de repetir.",
      })));
      report.notSent = ids.slice(offset + batch.length).map((photoId) => ({ photoId }));
      report.interruption = "A comunicação foi interrompida. Os próximos lotes não foram enviados.";
      notify(offset + batch.length);
      break;
    }
    batch.forEach((photoId) => {
      const matches = Array.isArray(results) ? results.filter((item) => item?.photoId === photoId) : [];
      const result = matches[0];
      if (matches.length !== 1 || result.action !== action || typeof result.status !== "string" || !result.status) {
        report.unconfirmed.push({ photoId, error: "Resposta ausente ou inválida. Consulte o estado antes de repetir." });
      } else if (result.status === "failed" || (action === "process" && result.queued !== true)) {
        report.failed.push({ ...result, error: result.error || "A operação não foi aplicada à foto." });
      } else {
        report.confirmed.push(result);
      }
    });
    notify(offset + batch.length);
    if (report.unconfirmed.length) {
      report.notSent = ids.slice(offset + batch.length).map((photoId) => ({ photoId }));
      report.interruption = "A resposta do lote ficou incompleta. Os próximos lotes não foram enviados.";
      break;
    }
  }
  return report;
}
